"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKWizardStep = void 0;
var common_1 = require("../../common");
/**
 * Abstract class representing one step of a GKWizard. It extends React.PureComponent and allows
 * communication between wizard and steps. Provdes built-in methods to access metadata and notify
 * wizard of validity changes.
 */
var GKWizardStep = /** @class */ (function (_super) {
    __extends(GKWizardStep, _super);
    function GKWizardStep() {
        // PROPERTIES
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Mechanism to set validity before wizard is mounted. Do not modify this directly.
         * @internal
         */
        _this._GK_INTERNAL_INITIAL_VALIDITY = null;
        // METHODS
        /**
         * Wire up notifications to GKWizard. Do not modify this directly.
         * @internal
         */
        _this._GK_INTERNAL_SET_STEP_VALIDITY = function (value) {
            _this._GK_INTERNAL_INITIAL_VALIDITY = value;
        };
        /**
         * Wire up getter to current step validity to GKWizard. Do not modify this directly.
         * @returns validity of current step
         */
        _this._GK_INTERNAL_GET_STEP_VALIDITY = function () {
            return Boolean(_this._GK_INTERNAL_INITIAL_VALIDITY);
        };
        /**
         * Indicate the validity of the current GKWizard step, or optionally target a different step if it is
         * dependent of the results of this one.
         * @param value the boolean value of validity state
         */
        _this.setWizardStepValidity = function (val) {
            _this._GK_INTERNAL_SET_STEP_VALIDITY(val);
            _this.forceUpdate();
        };
        /** Alias to GKWizardStep.prototype.setWizardStepValidity, setting the validity for current step to true */
        _this.setWizardStepValid = function () { return _this.setWizardStepValidity(true); };
        /** Alias to GKWizardStep.prototype.setWizardStepValidity, setting the validity for current step to false */
        _this.setWizardStepInvalid = function () {
            return _this.setWizardStepValidity(false);
        };
        /** Get the validity state of the current GKWizard step */
        _this.getWizardStepValidity = function () {
            return _this._GK_INTERNAL_GET_STEP_VALIDITY();
        };
        return _this;
    }
    return GKWizardStep;
}(common_1.GKPureComponent));
exports.GKWizardStep = GKWizardStep;
